import React from 'react'

export const SlAds = (props) => {
  const { id } = props

  const item = adsData.find((ad) => ad.id === id)

  return (
    <a
      href={item.url}
      target='_blank'
      onClick={(e) => {
        try {
          gtag('event', 'sl-ad-click', {
            value: 1.0,
            currency: 'USD',
          })
        } catch (error) {
          console.log(error)
        }
      }}
      className='sl-banner'
    >
      <img src={item.content.mobile.image} loading='lazy' />
      <img src={item.content.desktop.image} loading='lazy' />
    </a>
  )
}

const adsData = [
  {
    campaign: 'fashion',
    url: 'https://sellox.app/fashion?utm_source=blog&utm_medium=blog&utm_campaign=african-fashion&utm_id=african-fashion&utm_term=african+fashion',
    id: 'african-fashion',
    source: 'blog',
    medium: 'blog',
    name: 'african-fashion',
    content: {
      mobile: {
        image:
          'http://images.ctfassets.net/knu48znd5ht1/2xZoUpeBRey990C3GrTTFx/005d77a2c3909d1e963650390b56bf95/1.png',
      },
      desktop: {
        image:
          'http://images.ctfassets.net/knu48znd5ht1/aVlB46RiZCtUE3QmqBNtl/886697e60d0a724a0b064caac6c367d7/afrodapp.png',
      },
    },
  },
  {
    campaign: 'sellox',
    url: 'https://sellox.app?utm_source=blog&utm_medium=blog&utm_campaign=sellox-awareness&utm_id=sellox-awareness',
    id: 'sellox-awareness',
    source: 'blog',
    medium: 'blog',
    name: 'sellox-awareness',
    content: {
      mobile: {
        image:
          'http://images.ctfassets.net/knu48znd5ht1/2xZoUpeBRey990C3GrTTFx/005d77a2c3909d1e963650390b56bf95/1.png',
      },
      desktop: {
        image:
          'http://images.ctfassets.net/knu48znd5ht1/aVlB46RiZCtUE3QmqBNtl/886697e60d0a724a0b064caac6c367d7/afrodapp.png',
      },
    },
  },
]
